const pageTitle = {
  'Youtube Live Shopping': 'Connect to YouTube Shopping',
};

export default pageTitle;
